// React
import { useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
// コンポーネント
import PasswordResetInput from './PasswordResetInput';     // フォーム画面
import PasswordResetSuccess from './PasswordResetSuccess'; // 成功画面

const PasswordReset = () => {
    const [isSuccess, setIsSuccess] = useState(false);
    const location = useLocation();
    const [searchParams] = useSearchParams();
    
    const role = searchParams.get('role') || location.state?.role;

    return (
        <div className="bg">
            <div className="account-container">
                {isSuccess ? (
                    <PasswordResetSuccess role={role} />
                ) : (
                    <PasswordResetInput setIsSuccess={setIsSuccess} role={role} />
                )}
            </div>
        </div>
    );
};

export default PasswordReset;







